<template>
  <div :class="containerClasses">
    <template v-if="loading">
      <UiLoading v-if="newUiEnabled" />

      <div v-else class="d-flex justify-content-center">
        <b-spinner />
      </div>
    </template>
    <slot v-else />
  </div>
</template>

<script>
import { useNewUiEnabled } from "@/components/newUi/core/useNewUiEnabled";

export default {
  name: "Loading",

  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    containerClasses: {
      type: String,
      default: "",
    },
  },

  setup() {
    return { newUiEnabled: useNewUiEnabled() };
  },
};
</script>
